import React from "react"
import companyleague from "../../../assets/images/products/tipster/company_league.svg"
import { Trans, useTranslation } from '../../../plugins/i18next/ea-react-i18next';

const TipsterCompanyLeague: React.FC<{}> = () => {

  const { t } = useTranslation("components", { keyPrefix: 'products.tipster.tipsterCompanyLeague' });

  return (
    <div id="bookDemo" className={`subscribe-area tipster companyleague ptb-70`}>
      <div className="container-fluid hero-container tipster">
        <div className="tipster-row align-items-center">
          <div className="col-lg-8 col-md-12">
            <div className="subscribe-content tipster companyleague">
              <h2>{t("title")}</h2>
              <p> {(<Trans t={t}>{t("details")}</Trans>)}</p>
            </div>
          </div>  
          <div className="col-lg-4 col-md-12 tipster companyleague">
            <div className="companyleague-image">
              <img
                src={companyleague}
                alt="company league"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TipsterCompanyLeague
